module.exports = __webpack_public_path__ + "79bfaa33c638d2640ff6b6d9ac4d9acd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg80.jpeg
// module id = 95
// module chunks = 0